import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["documentTypeStore", "value", "onChange", "readOnly", "uploader"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';
var DocumentTypeSelect = function DocumentTypeSelect(_ref) {
  var documentTypeStore = _ref.documentTypeStore,
    value = _ref.value,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    uploader = _ref.uploader,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    types = _useState2[0],
    setTypes = _useState2[1];
  useEffect(function () {
    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return documentTypeStore.find({
                uploader: uploader,
                limit: 1000
              });
            case 2:
              data = _context.sent;
              setTypes(data);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();
    load();
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, _extends({
    placeholder: "Select document type"
  }, props, {
    isDisabled: props.disabled || readOnly,
    defaultOptions: true,
    options: types,
    value: value,
    getOptionValue: function getOptionValue(v) {
      return v.id;
    },
    getOptionLabel: function getOptionLabel(v) {
      return v.name;
    },
    onChange: function onChange(opt) {
      return _onChange(opt);
    }
  })));
};
export default observer(DocumentTypeSelect);
//# sourceMappingURL=index.js.map
